import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { Progress } from 'reactstrap';

const Loader = () => {
	return (
		<Box width="100%" height="100%">
            <Text>Obteniendo información...</Text>
			<Progress animated color="primary" value="100" />{' '}
		</Box>
	);
};

export default Loader;
